import type { CategoryObjectType } from './types';

export const allCategoryObjectTypes: CategoryObjectType[] = [
  'assets',
  'collections',
  'segments',
  'search',
  'custom_actions',
];
